import { useEffect, useState } from "react";
import { getReportsHistory } from "../../Services/Service";
import { formatDate, getCache } from "./utils";
import LoadingComponent from "../components/LoadingComponent";
import { NORECORDS } from "../../Services/CommonLibrary";


const ListItem = ({ history }) => {
    const _data = JSON.parse(history.form_body);
    return <div className="col-full border p-4 rounded d-flex align-items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            className="lucide lucide-file-text h-5 w-5 text-muted-foreground" >
            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
            <path d="M10 9H8"></path>
            <path d="M16 13H8"></path>
            <path d="M16 17H8"></path>
        </svg>
        <div className="d-flex justify-content-between align-items-center w-full">
            <div className="ps-4">
                <h4> {_data?.otherData?.reportType == 'referral' ? 'Referral' : 'Divisional'}  Report</h4>
                {
                    (_data?.div?.label && _data?.otherData?.reportType != 'referral') &&
                    <p>Division: {_data.div.label}</p>
                }
            </div>
            <div>
                <h5>{_data.admin_name}</h5>
                <small>{formatDate(history.created_at)}</small>
            </div>
        </div>
    </div>;
}

export default (({ activeKey }) => {
    const [histores, setHistores] = useState([]);
    const [loading, setLoading] = useState(false);
    const handleGetHistory = async () => {
        setLoading(true);
        try {
            const resp = await getReportsHistory();
            setHistores(resp.data.data);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        console.log(activeKey);
        if (activeKey == 'history') {
            handleGetHistory()
        }
    }, [activeKey])
    // const histores = getCache();
    return <div className='border rounded p-10 mt-8'>
        <h3 className="text-2xl font-semibold leading-none tracking-tight mb-4">
            Download History
        </h3>
        <div className="row g-3 align-items-center">
            { 
                loading && <LoadingComponent/>
            }
            {
                (histores.length ==0 && !loading)&& <NORECORDS message="History not found!" marginTop="50px" />
            }
            {
                histores.map((history, key) => <ListItem history={history} key={`history_${key}`} />)
            }
        </div>
    </div>;
});